module.exports = __webpack_public_path__ + "img/logo.b6c22772.png";